<template>
    <div class="custom-control custom-switch">
        <oc-checkbox-input
            class="custom-control-input"
            :id="id"
            :data="value"
            v-on="$listeners"
            v-bind="inputAttrs"
        />
        <oc-label-input
            class="custom-control-label"
            :for="id"
            v-bind="labelAttrs"
        >
            {{text}}
        </oc-label-input>
    </div>
</template>

<script>
export default {
    name: 'oc-switch-input',
    props: {
        id: {
            type: String,
            default(){
                return 'item-' + this._uid
            }
        },
        value: {
            type: Boolean
        },
        text: {
            type: String
        },
        inputAttrs: {
            type: Object
        },
        labelAttrs: {
            type: Object
        }
    }
}
</script>
